import { useCallback, useEffect, useRef, useState } from "react";

export default function useCountDown(initCount = 10) {
  const timeId = useRef<{ id: number }>({ id: -1 });
  const [count, setCount] = useState(initCount);

  const start = useCallback(() => {
    if (timeId.current.id !== -1) {
      clearInterval(timeId.current.id);
    }

    setCount(initCount);
    setCount((count) => count - 1);

    timeId.current.id = window.setInterval(() => {
      setCount((count) => count - 1);
    }, 1000);
  }, [initCount]);

  const stop = useCallback(() => {
    if (timeId.current.id !== -1) {
      clearInterval(timeId.current.id);
    }
  }, []);

  const clear = useCallback(() => {
    if (timeId.current.id !== -1) {
      clearInterval(timeId.current.id);
    }

    setCount(initCount);
  }, [initCount])

  useEffect(() => {
    const timer = timeId.current;

    return () => {
      if (timer.id !== -1) {
        clearInterval(timer.id);
      }
    };
  }, []);

  useEffect(() => {
    if (count === 0) {
      clearInterval(timeId.current.id);
    }
  }, [count]);

  return {
    count,
    start,
    stop,
    clear,
    isEnd: count === 0,
    isLoading: count !== initCount && count !== 0,
  };
}
